import React, { useContext } from 'react';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import { OrderTrackingDashboard } from './restaurant-delivery-map/OrderTrackingDashboard';
import './RestaurantDeliveryMap.scss';

const RestaurantDelivery = () => {
  const { onLoadInfoResponse } = useContext(GlobalStateDataContext);
  const kitchenName =
    onLoadInfoResponse?.data?.data?.data?.KitchenInfo?.kitchenName ?? 'Kitchen';

  return (
    <div className='order-map-page'>
      <div className='order-map-page__content'>
        <OrderTrackingDashboard branchLabel={kitchenName} />
      </div>
    </div>
  );
};

export default RestaurantDelivery;
